import script from "./ProjectsReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsReport.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsReport.vue?vue&type=style&index=0&id=7d40efcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d40efcb"]])

export default __exports__